module.exports = __webpack_public_path__ + "static/media/ge.080272a7.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ge.svg
// module id = 1238
// module chunks = 0